module.exports = __webpack_public_path__ + "static/img/unit_riskbg.79852c26.gif";